import { atom, useAtom, getDefaultStore } from 'jotai'

const proposalAtom = atom(null)

const useProposal = () => useAtom(proposalAtom)

export const getProposal = () => getDefaultStore().get(proposalAtom)

export const setProposal = (value) => {
  console.log({ nextProposal: value })
  getDefaultStore().set(proposalAtom, value)
}

export default useProposal
